import { render, staticRenderFns } from "./ClubsView.vue?vue&type=template&id=1af43715&scoped=true&"
import script from "./ClubsView.vue?vue&type=script&lang=ts&"
export * from "./ClubsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af43715",
  null
  
)

export default component.exports